import { breakpoints, spacing } from '@naf/theme';
import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { PhoneIphone } from '@styled-icons/material-outlined/PhoneIphone';
import { Drafts } from '@styled-icons/material-outlined/Drafts';

export const PageWrapper = styled.div`
  background-color: #fffaec;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${breakpoints.s}) {
    background-color: transparent;
    padding: 0;
    align-items: stretch;
  }
`;

export const LoginBox = styled.div`
  width: 340px;
  background-color: white;
  border-radius: ${spacing.space12};
  padding: 2rem;
  padding-bottom: 4rem;
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.s}) {
    width: 100%;
    border-radius: 0;
  }
`;

export const Header = styled.div`
  text-align: center;

  img {
    height: 54px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: ${spacing.space12};
  display: flex;
  flex-direction: column;
  gap: ${spacing.space24};
`;

export const LoginButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    height: '44px',
    borderRadius: theme.spacing(1),
    border: '1px solid #c1c1c1',
  },
}));

export const FooterText = styled.span``;

export const RegisterLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;

  &:hover {
    text-decoration: none;
  }
`;

export const PhoneIcon = styled(PhoneIphone)`
  margin-right: ${spacing.space8};
`;

export const DraftsIcon = styled(Drafts)`
  margin-right: ${spacing.space8};
`;

export const Logo = styled.img`
  cursor: pointer;
`;
